module.exports = __webpack_public_path__ + "img/banner.2a43b352.png";